'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStarburst = function TiStarburst(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.8 16.8l1.9-3.9c0.2-0.3 0.2-0.6 0-0.8-0.1-0.3-0.4-0.4-0.7-0.4l-4.4-0.3-0.3-4.4c0-0.3-0.1-0.6-0.4-0.7s-0.5-0.2-0.8 0l-3.9 1.9-2.5-3.7c-0.3-0.4-1.1-0.4-1.4 0l-2.5 3.7-3.9-1.9c-0.3-0.2-0.6-0.2-0.8 0-0.3 0.1-0.4 0.4-0.4 0.7l-0.3 4.4-4.4 0.3c-0.3 0-0.6 0.1-0.7 0.4-0.2 0.2-0.2 0.5 0 0.8l1.9 3.9-3.7 2.5c-0.2 0.2-0.3 0.4-0.3 0.7s0.1 0.5 0.3 0.7l3.7 2.5-1.9 3.9c-0.2 0.3-0.2 0.6 0 0.8 0.1 0.3 0.4 0.4 0.7 0.4l4.4 0.3 0.3 4.4c0 0.3 0.1 0.6 0.4 0.7 0.2 0.2 0.5 0.2 0.8 0l3.9-1.9 2.5 3.7c0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3l2.5-3.7 3.9 1.9c0.3 0.2 0.6 0.2 0.8 0s0.4-0.4 0.4-0.7l0.3-4.4 4.4-0.3c0.3 0 0.6-0.1 0.7-0.4 0.2-0.2 0.2-0.5 0-0.8l-1.9-3.9 3.7-2.5c0.2-0.2 0.3-0.4 0.3-0.7s-0.1-0.5-0.3-0.7l-3.7-2.5z' })
        )
    );
};

exports.default = TiStarburst;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/starburst.js
// module id = 2210
// module chunks = 0